"use client";

import { CarList } from "@/components/carList/carList";
import { Filters } from "@/components/filters/filters";
import { FilterAndCarsWrapper } from "@/app/components/filtersAndCarsWrapper";
import { DepartmentFilterDesktop } from "./departmentFilterDesktop";
import { useFilters } from "@/components/filters/hooks/useFilters";
import { MobileFilter } from "@/components/filters/mobile/mobileFilter";

interface Props {
  initialDepartmentIds: string[];
  departmentSlug: string;
  dealerName: string;
}

export const PageContent = ({
  initialDepartmentIds,
  departmentSlug,
  dealerName,
}: Props) => {
  const { departmentsFilter } = useFilters();

  return (
    <>
      {departmentsFilter && departmentsFilter.length > 0 && (
        <DepartmentFilterDesktop />
      )}
      <FilterAndCarsWrapper>
        <Filters departmentSlug={departmentSlug} />
        <MobileFilter
          departmentIds={initialDepartmentIds}
          departmentSlug={departmentSlug}
        />
        <CarList
          departmentIds={initialDepartmentIds}
          departmentSlug={departmentSlug}
          dealerName={dealerName}
        />
      </FilterAndCarsWrapper>
    </>
  );
};
